import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkComponent", "href", "selectedFiltersCount", "isLoading", "onClick"];
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { MoreFiltersLink } from './more-filters.styled';
import { getTrigger, useAnalytics } from '../../analytics';
import { onMoreFiltersSelected } from '../../analytics/events';
import { messages } from '../../../messages';
var MoreFilters = function MoreFilters(_ref) {
  var linkComponent = _ref.linkComponent,
    href = _ref.href,
    selectedFiltersCount = _ref.selectedFiltersCount,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var onMoreFiltersClicked = useCallback(function (event) {
    var trigger = getTrigger(event);
    onClick === null || onClick === void 0 || onClick();
    fireAnalyticsEvent(onMoreFiltersSelected({
      trigger: trigger,
      selectedFiltersCount: selectedFiltersCount
    }));
  }, [fireAnalyticsEvent, selectedFiltersCount, onClick]);
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MoreFiltersLink, _extends({}, rest, {
    linkComponent: linkComponent,
    href: href,
    onClick: onMoreFiltersClicked
  }), /*#__PURE__*/React.createElement(FormattedMessage, messages.more_filters));
};
export default MoreFilters;